import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import * as R from 'ramda';
import { Box, Typography } from '@mui/material';

// Utilities
import { capitalize } from 'utils/helpers/format';

const headerStyles = theme => ({
  backgroundColor: theme.palette.graphic.lighter,
  color: theme.palette.primary.dark,
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
});
const itemStyles = theme => ({
  backgroundColor: theme.palette.surface.medium,
  borderBottom: `solid 1px ${theme.palette.graphic.light}`,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
});
const subheaderStyles = theme => ({
  ...theme.typography.subtitle1,
  background: theme.palette.graphic.light,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
});

const SummaryStep = ({
  areAllCustomersAllowed,
  authorizationBy,
  enabledOptions,
  selectedCustomers,
  supplier,
  viewBySelection,
}) => {
  const listTitle = authorizationBy === 'carrier' ? 'Locations' : 'Carriers';

  const allowAll = areAllCustomersAllowed === 'true';

  return (
    <>
      <Typography color="inherit" sx={headerStyles} variant="subtitle1">
        Summary
      </Typography>

      <Typography color="textPrimary" sx={subheaderStyles} variant="subtitle1">
        1. Details
      </Typography>

      <Box sx={itemStyles}>
        <Typography sx={{ color: 'text.secondary' }} variant="body1">
          Affiliate
        </Typography>
        <Typography sx={{ color: 'text.primary' }} variant="subtitle1">
          {supplier.label}
        </Typography>
      </Box>
      <Box sx={itemStyles}>
        <Typography sx={{ color: 'text.secondary' }} variant="body1">
          {capitalize(authorizationBy)}
        </Typography>
        <Typography sx={{ color: 'text.primary', textAlign: 'right' }} variant="subtitle1">
          {authorizationBy === 'carrier' ? viewBySelection.carrierName : viewBySelection.nameShort}
        </Typography>
      </Box>

      <Box sx={itemStyles}>
        <Typography sx={{ color: 'text.secondary' }} variant="body1">
          Restricted Customers?
        </Typography>
        <Typography sx={{ color: 'text.primary' }} variant="subtitle1">
          {allowAll ? 'No' : 'Yes'}
        </Typography>
      </Box>

      <Typography color="text.primary" sx={subheaderStyles} variant="subtitle1">
        2. {listTitle}
      </Typography>
      {R.map(
        ({ label, value }) => (
          <Box key={value} sx={itemStyles}>
            <Typography variant="body1">{label}</Typography>
          </Box>
        ),
        enabledOptions
      )}
      <Typography color="text.primary" sx={subheaderStyles} variant="subtitle1">
        3. Customers Allowed
      </Typography>
      {allowAll ? (
        <Box sx={itemStyles}>
          <Typography variant="body1">All Customers</Typography>
        </Box>
      ) : (
        selectedCustomers.map(({ customerName: label, customerId: value }) => (
          <Box key={value} sx={itemStyles}>
            <Typography variant="body1">{label}</Typography>
          </Box>
        ))
      )}
    </>
  );
};

export default SummaryStep;

SummaryStep.propTypes = {
  areAllCustomersAllowed: string.isRequired,
  authorizationBy: string.isRequired,
  enabledOptions: arrayOf(shape({})).isRequired,
  selectedCustomers: arrayOf(shape({})).isRequired,
  supplier: shape({}).isRequired,
  viewBySelection: shape({}).isRequired,
};
